<template>
  <v-card outlined class="hover-border">
    <v-list>
      <v-list-item>
        <v-list-item-avatar>
          <img :src="organization.avatar" v-if="organization.avatar" />
          <v-icon v-else v-text="$vuetify.icons.values.organization"></v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ organization.display }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-card-text>
      <AvatarList :users="users" align-right />
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer />
      <v-btn color="default" icon depressed small @click="show(organization)">
        <v-icon small>{{ $vuetify.icons.values.view }}</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { AvatarList } from '@argon/iam/components'
export default {
  name: 'OrganizationCard',
  components: { AvatarList },
  props: {
    organization: { type: Object, required: true },
    show: { type: Function, required: true }
  },
  computed: {
    users() {
      return this.organization.users ? this.organization.users.map((x) => x.user) : []
    }
  }
}
</script>

<style></style>
